import { Component, OnInit } from '@angular/core';
import { SampleService } from '../services/sample.service'
import { saveAs } from 'file-saver';

@Component({
  moduleId: module.id,
  templateUrl: '../../Templates/sample-list-audit.component.html'
})

export class SampleListAuditComponent implements OnInit {
  fileToUpload: File = null;

  constructor(private sampleService: SampleService) { }

  private saveToFileSystem(response) {
    console.log(response);
    const contentDispositionHeader: string = response.headers.get('content-disposition');
    const parts: string[] = contentDispositionHeader.split(';');
    const filename = parts[1].split('=')[1];
    console.log(filename);
    //const blob = new File(response.body, filename, { type: 'text/plain;charset=utf-8' });
    saveAs(response.body, filename);
  }

  uploadList(files: FileList) {
    this.fileToUpload = files.item(0);
    console.log(this.fileToUpload);
    this.sampleService.postFile(this.fileToUpload).then(response => this.saveToFileSystem(response))
  }

  ngOnInit(): void { }
}
